import axios from 'axios';
import { logger } from '../logger';
import { CABINET_PATH } from '../../msg/inviteLink';

let isRefreshing = false;
let refreshSubscribers = [];

// INF-2: API-хост берём из env сборки; по умолчанию ПУСТАЯ строка = same-origin
// (клиент раздаётся тем же nginx, что проксирует /api/) — домен больше не зашит
// в бандл, один образ работает на любом хосте. Абсолютный хост можно задать
// через REACT_APP_API_BASE (напр. отдельный API-домен).
// trailing slash режем: '/api/v1/' конкатенируется ниже, иначе хост с '/' на
// конце дал бы '//api/v1/...' (Codex).
export const BASE_API_URL = (process.env.REACT_APP_API_BASE || '').replace(/\/+$/, '');

const axiosInstance = axios.create({
  baseURL: `${BASE_API_URL}/api/v1/`,
});

axiosInstance.interceptors.request.use(
  (config) => {
    const access_token = localStorage.getItem('access_token');
    if (access_token) {
      config.headers.Authorization = `Bearer ${access_token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true; 

      if (!isRefreshing) {
        isRefreshing = true;
        try {
          const refresh_token = document.cookie.replace(
            /(?:(?:^|.*;\s*)refresh_token\s*\=\s*([^;]*).*$)|^.*$/,
            '$1'
          );

          localStorage.removeItem('access_token');

          const response = await axios.post(
            `${BASE_API_URL}/api/v1/website/refresh`,
            {},
            {
              headers: {
                Authorization: `Bearer ${refresh_token}`,
              },
            }
          );

          const new_access_token = response.data.access_token;
          localStorage.setItem('access_token', new_access_token);

          refreshSubscribers.forEach((callback) => callback(new_access_token));
          refreshSubscribers = [];
          isRefreshing = false;

          logger.debug('access-токен обновлён по refresh');
          originalRequest.headers.Authorization = `Bearer ${new_access_token}`;
          return axiosInstance(originalRequest);
        } catch (refreshError) {
          logger.error('Ошибка обновления токена, разлогиниваем', refreshError);
          isRefreshing = false;

          localStorage.removeItem('access_token');
          document.cookie = 'refresh_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';

          // 🔴 С ключом кабинета (ревью WEB-28, второй заход). Голый корень
          // в браузере, где жива сессия участника, уводит в переписку — и
          // вышедший владелец делает лишний круг вместо формы входа.
          window.location.href = CABINET_PATH;
          return Promise.reject(refreshError);
        }
      } else {
        return new Promise((resolve) => {
          refreshSubscribers.push((new_access_token) => {
            originalRequest.headers.Authorization = `Bearer ${new_access_token}`;
            resolve(axiosInstance(originalRequest));
          });
        });
      }
    }

    if (error.response?.status === 401) {
      localStorage.removeItem('access_token');
      document.cookie = 'refresh_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
      // 🔴 То же и на прямом 401 без refresh (ревью WEB-28).
      window.location.href = CABINET_PATH;
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
